
import React from 'react';
import { BookingDetails } from '@/types';
import { ArrowLeft, Droplets, Sun, Trees } from "lucide-react";
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface ScheduleHeaderProps {
  bookingDetails: BookingDetails | null;
}

const ScheduleHeader: React.FC<ScheduleHeaderProps> = ({ bookingDetails }) => {
  const navigate = useNavigate();

  const getServiceIcon = () => {
    if (!bookingDetails?.serviceType) return null;
    
    switch (bookingDetails.serviceType) {
      case "Indoor":
        return <Droplets className="h-4 w-4 text-gray-600 mr-2" />;
      case "Outdoor":
        return <Sun className="h-4 w-4 text-gray-600 mr-2" />;
      case "Combined":
        return <Trees className="h-4 w-4 text-gray-600 mr-2" />;
      default:
        return null;
    }
  };

  return (
    <div className="border-b border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-black mb-2">Schedule Service</h1>
            <p className="font-cousine text-gray-600 flex items-center">
              {getServiceIcon()}
              Select your preferred date and time for {bookingDetails?.serviceType?.toLowerCase() || ''} plant care
            </p>
          </div>
          <Button 
            variant="outline" 
            onClick={() => navigate('/booking')}
            className="border-gray-300 text-black hover:bg-gray-50 font-cousine"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> 
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleHeader;
